import React from "react";

import canstar from "../assets/images/canstar-2021.png";
import ratecity from "../assets/images/ratecity-2020.svg";
import wemoneyLender from "../assets/images/wemoney-lender-2022.svg";
import wemoneyPlCs from "../assets/images/wemoney-pl-cs-2022.svg";
import wemoneyRates from "../assets/images/wemoney-rates-2022.svg";
import wemoneySlCs from "../assets/images/wemoney-sl-cs-2022.svg";
import awardsStyle from "./awards-widget.scss";

interface Props {
  location?: "widget" | "footer";
}

export const AwardsWidget: React.FC<Props> = (props) => {
  const { location = "widget" } = props;

  return (
    <div className={`awards-${location}-wrapper`}>
      <style jsx>{awardsStyle}</style>
      <p>Wisr is an award-winning lender</p>
      <div className="awards-widget">
        <img src={canstar} className="canstar" style={{ zIndex: 6 }} />
        <img src={ratecity} style={{ zIndex: 5 }} />
        <img src={wemoneyLender} style={{ zIndex: 4 }} />
        <img src={wemoneyRates} style={{ zIndex: 3 }} />
        <img src={wemoneySlCs} style={{ zIndex: 2 }} />
        <img src={wemoneyPlCs} style={{ zIndex: 1 }} />
      </div>
      <p className="small-text">
        <strong>(ASX: WZR)</strong> <span>|</span>
        <br /> &copy; Wisr Services Pty Ltd 2022 ACN 616 806 949 <span>|</span>
        <br /> Wisr Finance Pty Ltd ACN 119 503 221 <span>|</span>
        <br /> Australian Credit Licence & Australian Financial
        <br /> Service Licence No. 458572
      </p>
    </div>
  );
};
